import { useRef } from 'react';
import { useRouter } from '@atlassian/react-resource-router';

export const useRedirectAutoOpenReleaseModal = (
	openModal: () => void,
	loadReleaseNoteModal: () => void,
): void => {
	const [{ query }] = useRouter();
	const hasModalBeenOpened = useRef(false);

	if (hasModalBeenOpened.current === false && query.isReleaseNoteModalOpen === 'true') {
		loadReleaseNoteModal();
		openModal();
		hasModalBeenOpened.current = true;
	}
};
